"use strict";
// _partialFile.js

{
  document.addEventListener("DOMContentLoaded", function () {
    // クリックするボタンの要素を取得
    const button = document.querySelector(
      ".p-lowerRecruit__memberAnnouncementRead",
    );
    // 表示したいコンテンツの要素を取得
    const contents = document.querySelector(
      ".p-lowerRecruit__memberMessageContents",
    );

    // ボタンとコンテンツの両方がページに存在する場合のみ、処理を実行する
    if (button && contents) {
      // ボタンがクリックされたら
      button.addEventListener("click", function () {
        // コンテンツのスタイルを display: block; に変更する
        contents.style.display = "block";
      });
    }
  });
}
